import { Component } from 'react';

export class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        var xhr = new XMLHttpRequest();
        xhr.open("POST", "../listinginput/ajax/LogError?sErrorMessage=" + encodeURIComponent(error.message) + "&sStackTrace=" + encodeURIComponent(info.componentStack), true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send();

        //The error will be logged by window.onerror in the cshtml, so just need to redirect to the error page here
        window.location.href = window.location.origin + "/listinginput/error";
        return true;
    }

    render() {
        if (this.state.hasError) {
            return null;
        }
        return this.props.children;
    }
}